import { Gamepad, Ticket, Users } from 'lucide-static';
import { Icon } from './Icon';
import type { Path } from 'engine/router';
import { role } from 'src/backend';

export function DashboardOverview() {
	return (
		<div class="p-6">
			<h2 class="text-2xl font-bold text-gray-800 dark:text-white">Welkom bij de Bedrijfshelden Console 👋</h2>
			<p class="mb-6 text-gray-600 dark:text-gray-300">
				Klik hieronder om direct door te gaan naar je {role == 'admin' ? 'games, licenties of users' : 'licenties'}.
			</p>

			<div class="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-4">
				{role == 'admin' && <Card icon={Gamepad} label="Games" href={'/dashboard/games'} />}
				<Card icon={Ticket} label="Licenses" href={'/dashboard/licenses'} />
				{role == 'admin' && <Card icon={Users} label="Users" href={'/dashboard/users'} />}
			</div>
		</div>
	);
}
type CardProps = {
	icon: string;
	label: string;
	href: Path;
};

function Card({ icon, label, href }: CardProps) {
	return (
		<a href={href}>
			<div
				class={`group flex cursor-pointer items-center gap-4 rounded-2xl bg-white p-4 shadow transition-colors duration-200 hover:bg-theme-600 hover:text-white dark:bg-gray-800`}
			>
				<div class={`rounded-full bg-gray-100 p-3 transition-colors duration-200 group-hover:bg-theme-700 dark:bg-gray-700`}>
					<Icon icon={icon} class={`group-hover:text-white`} />
				</div>
				<div>
					<p class="text-sm text-gray-500 transition-colors duration-200 group-hover:text-white dark:text-gray-400">{label}</p>
				</div>
			</div>
		</a>
	);
}
